__turbopack_context__.v({
  "aboutWrapper": "z0JGWa_aboutWrapper",
  "changelogTitle": "z0JGWa_changelogTitle",
  "codeTreeToolbar": "z0JGWa_codeTreeToolbar",
  "codesTools": "z0JGWa_codesTools",
  "detailsHeading": "z0JGWa_detailsHeading",
  "introduction": "z0JGWa_introduction",
  "searchScope": "z0JGWa_searchScope",
  "tabList": "z0JGWa_tabList",
  "tabsPanel": "z0JGWa_tabsPanel",
  "wrapper": "z0JGWa_wrapper",
});
